import React from 'react';
import { Form,Dropdown } from 'react-bootstrap';

const SelectDropDownComponent = (props) => {
  const options = (props.options.options) ? props.options.options : [];
  return (
    options.length > 0 ? (
      <Form.Group>
      <Dropdown>
        <Dropdown.Toggle variant="default" className="productCategory form-control" id="dropdown-basic">
        
        {(props.options.selectedValue) ? props.options.selectedValue : props.defaultOption }
      
        </Dropdown.Toggle>
        <Dropdown.Menu >       
          {options.map((subCat, key) =>
          <Dropdown.Item key={key} data-catelevel='sub' data-indexc={props.indexKey} data-selectindex={props.indexKey} data-catindex={key} data-children={JSON.stringify(subCat.children)} data-name="category"  onClick={props.changeEvent} data-value={subCat.catName} data-slug={subCat.slug} className={props.options.selectedValue ===  subCat.catName ? 'selected' : ''}>{subCat.catName}</Dropdown.Item>    
              
            ) }     
         
        </Dropdown.Menu>
      </Dropdown>
      </Form.Group>

     /*  <Form.Group controlId={"productSubCategory"+props.indexKey}>      
      <Form.Control as="select" value={(props.options.selectedValue) ? props.options.selectedValue : '' } data-selectindex={props.indexKey} name="category" className="" onChange={props.changeEvent} >
        <option value=''>{props.defaultOption}</option>
        {options.map((subCat, key) =>
          <option key={key} data-catelevel='sub' data-catindex={key} data-children={JSON.stringify(subCat.children)} value={subCat.catName}>{subCat.catName}</option>
        )}
      </Form.Control></Form.Group> */
    ) : ''
  )
};

export default SelectDropDownComponent;